import { Skeleton, Grid, useTheme } from '@mui/material';
import { WhiteContainer } from 'src/style/common';
import { CardTitleContainer } from 'src/pages/Settings/components/BillingInfo/index';

const GeneralSkeleton = () => {
  const theme = useTheme();
  return (
    <>
      <WhiteContainer container={true}>
        <div data-testid="billing-skeleton" />
        <Grid item={true} xs={12}>
          <Skeleton variant="rectangular" width="60px" height={25} style={{ marginBottom: theme.spacing(2) }} />
          <Skeleton variant="rectangular" width="300px" height={25} style={{ marginBottom: theme.spacing(2) }} />
          <CardTitleContainer>
            <Skeleton variant="rectangular" width="100%" height={50} style={{ marginBottom: theme.spacing(3) }} />
          </CardTitleContainer>
          <Skeleton variant="rectangular" width="90px" height={25} style={{ marginBottom: theme.spacing(2) }} />
          <Skeleton variant="rectangular" width="100%" height={50} style={{ marginBottom: theme.spacing(2) }} />
          <Skeleton variant="rectangular" width="100%" height={50} style={{ marginBottom: theme.spacing(2) }} />
          <Skeleton variant="rectangular" width="100%" height={50} style={{ marginBottom: theme.spacing(2) }} />
          <Skeleton variant="rectangular" width="100%" height={50} style={{ marginBottom: theme.spacing(2) }} />
          <Skeleton variant="rectangular" width="100%" height={50} style={{ marginBottom: theme.spacing(2) }} />
          <Skeleton variant="rectangular" width="100%" height={50} style={{ marginBottom: theme.spacing(2) }} />
          <Skeleton variant="rectangular" width="100%" height={50} style={{ marginBottom: theme.spacing(2) }} />
          <Skeleton variant="rectangular" width="100%" height={50} style={{ marginBottom: theme.spacing(2) }} />
        </Grid>
        <Grid item={true} xs={12}>
          <CardTitleContainer />
        </Grid>
      </WhiteContainer>
      <WhiteContainer>
        <Skeleton variant="rectangular" width="130px" height={25} style={{ marginBottom: theme.spacing(2) }} />
        <Skeleton variant="rectangular" width="450px" height={25} style={{ marginBottom: theme.spacing(2) }} />
      </WhiteContainer>
    </>
  );
};

export default GeneralSkeleton;
